import { useInfiniteQuery } from '@tanstack/react-query';

import MerchandisingCollectionsService, {
  MerchandisingCollectionsQueryFilterDto,
} from '@/services/MerchandisingCollectionsService';

export const MERCHANDISING_COLLECTIONS_QUERY_KEY = ['merchandisingCollections'];

export function useGetMerchandisingCollections(
  queryFilterDto?: Partial<MerchandisingCollectionsQueryFilterDto>,
) {
  const { data, isFetching, isFetchingNextPage, hasNextPage, fetchNextPage } =
    useInfiniteQuery({
      queryKey: [...MERCHANDISING_COLLECTIONS_QUERY_KEY, queryFilterDto],
      initialPageParam: queryFilterDto?.page ?? 1,
      queryFn: ({ pageParam }) =>
        MerchandisingCollectionsService.findCollections({
          page: pageParam,
          limit: queryFilterDto?.limit ?? 10,
          name: queryFilterDto?.name,
          orderBy: queryFilterDto?.orderBy,
          orderDirection: queryFilterDto?.orderDirection,
        }),
      getNextPageParam: (lastPage, _allPages, lastPageParam) => {
        const { currentPage, totalPages } = lastPage;

        if (currentPage === totalPages || totalPages === 0) {
          return null;
        }

        return lastPageParam + 1;
      },
    });

  const merchandisingCollections = data?.pages.flatMap((page) => page?.items);

  return {
    merchandisingCollections: merchandisingCollections ?? [],
    isFetching,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
  };
}
